const localAPI = 'https://map.dataeye.jp/api';
const fastAPI = 'https://map.dataeye.jp/api-infowindow';
// const localAPI = 'https://map.dataeye.jp/api';

// 人口密度と色分けの対応
const THRESHOLD2048 = {
  '0':'rgba(42, 0, 255, 0.5)',
  '64':'rgba(0, 102, 255, 0.5)',
  '128':'rgba(0, 240, 255, 0.5)',
  '256':'rgba(114, 255, 0, 0.5)',
  '512':'rgba(255, 222, 0, 0.5)',
  '1024':'rgba(255, 131, 20, 0.5)',
  '2048':'rgba(255, 0, 66, 0.5)',
};

export default {
  localAPI,
  fastAPI,
  THRESHOLD2048
}
